import { memo } from 'react';
import { MultiToggleGroup } from './ui/multi-toggle-group';
import {
  CommonGem,
  UncommonGem,
  RareGem,
  EpicGem,
  ShowcaseGem,
} from './icons/FacetIcons';

const GEM = 22;

const RARITY_OPTIONS = [
  { value: 'Common',   label: 'Common',   icon: <CommonGem size={GEM} /> },
  { value: 'Uncommon', label: 'Uncommon', icon: <UncommonGem size={GEM} /> },
  { value: 'Rare',     label: 'Rare',     icon: <RareGem size={GEM} /> },
  { value: 'Epic',     label: 'Epic',     icon: <EpicGem size={GEM} /> },
  { value: 'Showcase', label: 'Showcase', icon: <ShowcaseGem size={GEM} /> },
];

export interface RarityFilterProps {
  selected: string[];
  /** Called with the toggled rarity value — parent handles add/remove. */
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
}

export const RarityFilter = memo(function RarityFilter({
  selected,
  onChange,
  label = 'Rarity',
  disabled = false,
}: RarityFilterProps) {
  return (
    <MultiToggleGroup
      label={label}
      options={RARITY_OPTIONS}
      selected={selected}
      onChange={onChange}
      disabled={disabled}
      wrap
    />
  );
});
